import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPost, axiosPut } from 'Redux/axiosHelper'
import {
  CreateLeaguePracticePayload,
  LeaguePracticeRespType,
  UpdateLeaguePracticePayload,
} from 'types/league/leaguePractice'

export type { PracticeSession } from 'types/league/leaguePractice'

const getLeaguePracticeSchedule = async (params: {
  leagueId: string
  organizationId?: string
}) => {
  const response = await axiosGet('v1/league-practice-schedule', params)
  return response.data
}

export const useGetLeaguePracticeSchedule = (params: {
  leagueId: string
  organizationId?: string
}) => {
  return useQuery<LeaguePracticeRespType[]>(
    ['league-practice-schedule', params.leagueId],
    () => getLeaguePracticeSchedule(params),
    { enabled: !!params.leagueId },
  )
}

const createLeaguePractice = async (payload: CreateLeaguePracticePayload) => {
  const response = await axiosPost(payload, 'v1/league-practice-schedule')
  return response.data
}

export const useCreateLeaguePractice = () => {
  const queryClient = useQueryClient()
  return useMutation(createLeaguePractice, {
    onSuccess: () => {
      queryClient.invalidateQueries(['league-practice-schedule'])
    },
  })
}

const updateLeaguePractice = async ({
  payload,
  PracticeId,
}: {
  payload: UpdateLeaguePracticePayload
  PracticeId: string
}) => {
  const response = await axiosPut(payload, `v1/league-practice-schedule/${PracticeId}`)
  return response.data
}

export const useUpdateLeaguePractice = () => {
  const queryClient = useQueryClient()
  return useMutation(updateLeaguePractice, {
    onSuccess: () => {
      queryClient.invalidateQueries(['league-practice-schedule'])
    },
  })
}

const deleteLeaguePractice = async (PracticeId: string) => {
  const response = await axiosDelete(`v1/league-practice-schedule/${PracticeId}`)
  return response.data
}

export const useDeleteLeaguePractice = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeaguePractice, {
    onSuccess: () => {
      queryClient.invalidateQueries(['league-practice-schedule'])
    },
  })
}
